import head from 'ramda/src/head'

export const getProjects = db =>
  db
    .post('/_find', { selector: { type: 'project' }, limit: 1000 }, { 'axios-retry': { retries: 4 } })
    .then(resp => resp.data.docs)

export const getProjectsExcept = (db, _id) =>
    db
      .post('/_find', { selector: { type: 'project', $not: { _id } }, limit: 1000 }, { 'axios-retry': { retries: 4 } })
      .then(resp => resp.data.docs)

export const getProjectUpdatedAt = db =>
  db
    .post('/_find', { selector: { type: 'project' }, limit: 1000, fields: ['_id', 'updatedAt'] }, { 'axios-retry': { retries: 4 } })
    .then(resp => resp.data.docs)

export const getSettings = db =>
  db
    .post('/_find', { selector: { type: 'settings' } }, { 'axios-retry': { retries: 4 } })
    .then(resp => head(resp.data.docs))



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/findBySelector.js